export default {
  SET_USERS(state, users) {
    state.users = users
  },
  SET_USERS_COUNT(state, count) {
    state.usersCount = count
  },
  SET_USERS_QUERY(state, query) {
    state.query = query
  },
  SET_USERS_LIMIT(state, limit) {
    state.limit = limit
  },
  SET_USERS_SKIP(state, skip) {
    state.skip = skip
  }
}
